import * as _ from 'lodash';
import { VueCharts, mixins } from 'vue-chartjs';
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
import { getDimensionElementTotals, getOverallScore } from '@/services/analysis';

const { reactiveProp } = mixins;

const maxColor = [96,96,96];
const minColor = [196,196,196];

const barchartData = {
  labels: [],
  datasets: [
    {
      label: '1st Gear',
      backgroundColor: '#FF0000',
      xAxisID: 'valuesx',
      data: [60],
      datalabels: {
        anchor: 'center',
        align: 'start',
        offset: '-15',
        color: '#000000',
        font:{
          family: "Stag-Black",
          size: "18"
        },
        formatter(value) {
          return value > 0 ? '1st Gear' : '';
        }
      }
    },
    {
      label: '2nd Gear',
      backgroundColor: '#FF9D5B',
      xAxisID: 'valuesx',
      data: [10],
      datalabels: {
        anchor: 'center',
        offset: '-15',
        align: 'start',
        color: '#000000',
        font:{
          family: "Stag-Black",
          size: "18"
        },
        formatter(value) {
          return value > 0 ? '2nd Gear' : '';
        }
      }

    },
    {
      label: '3rd Gear',
      backgroundColor: '#FFE161',
      xAxisID: 'valuesx',
      data: [10],
      datalabels: {
        anchor: 'center',
        offset: '-15',
        align: 'start',
        color: '#000000',
        font:{
          family: "Stag-Black",
          size: "18"
        },
        formatter(value) {
          return value > 0 ? '3rd Gear' : '';
        }
      }
    },
    {
      label: '4th Gear',
      backgroundColor: '#92D050',
      xAxisID: 'valuesx',
      data: [20],
      datalabels: {
        anchor: 'center',
        offset: '-15',
        align: 'start',
        color: '#000000',
        font:{
          family: "Stag-Black",
          size: "18"
        },
        formatter(value) {
          return value > 0 ? '4th Gear' : '';
        }
      }
    }
  ]
};


export default {
  extends: VueCharts.Bar,
  components: {
    ChartJsPluginDataLabels
  },
  mixins: [reactiveProp],
  props: ['chartData', 'overallScore', 'skipOverallBar', 'yearDimension', 'yearDimensionIndex', 'periodDimension', 'periodDimensionIndex', 'yearPeriodBar', 'yearsAndPeriodsAsBars', 'programmeName'],
  watch: {
    chartData: {
      handler(newData) {
        if (newData) this.draw();
      }
    },
    overallScore: {
      handler(newData) {
        if (newData) this.draw();
      }
    },
    skipOverallBar: {
      handler(newData) {
        this.draw();
      }
    },
    yearsAndPeriodsAsBars: {
      handler(newData) {
        this.draw();
      }
    }
  },
  mounted() {

    this.addPlugin({
      beforeDraw(chartInstance) {
        const ctx = chartInstance.chart.ctx; // eslint-disable-line prefer-destructuring
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
      }
    });
    if (this.chartData) this.draw();
  },
  methods: {
    draw() {

      const newChartData = _.cloneDeep(barchartData);

      //different programmes, different colors/fonts
      if (this.programmeName === "CoR Culture") {
        newChartData.datasets[0].backgroundColor = '#0A133D';
        newChartData.datasets[0].datalabels.font.family = 'Calibri';
        newChartData.datasets[0].datalabels.color = '#FFFFFF';
        newChartData.datasets[0].label = '1st';
        newChartData.datasets[0].datalabels.formatter = (value) => value > 0 ? '1st' : '';
        newChartData.datasets[0].borderWidth = 0;
        newChartData.datasets[1].backgroundColor = '#6ABF3D';
        newChartData.datasets[1].datalabels.font.family = 'Calibri';
        newChartData.datasets[1].datalabels.color = '#FFFFFF';
        newChartData.datasets[1].label = '2nd';
        newChartData.datasets[1].datalabels.formatter = (value) => value > 0 ? '2nd' : '';
        newChartData.datasets[1].borderWidth = 0;
        newChartData.datasets[2].backgroundColor = '#A5A5A5';
        newChartData.datasets[2].datalabels.font.family = 'Calibri';
        newChartData.datasets[2].datalabels.color = '#FFFFFF';
        newChartData.datasets[2].label = '3rd';
        newChartData.datasets[2].datalabels.formatter = (value) => value > 0 ? '3rd' : '';
        newChartData.datasets[2].borderWidth = 0;
        newChartData.datasets[3].backgroundColor = '#0A81D1';
        newChartData.datasets[3].datalabels.font.family = 'Calibri';
        newChartData.datasets[3].datalabels.color = '#FFFFFF';
        newChartData.datasets[3].label = '4th';
        newChartData.datasets[3].datalabels.formatter = (value) => value > 0 ? '4th' : '';
        newChartData.datasets[3].borderWidth = 0;
      }

      let dataIndex = 0;

      /**
       * Painful.  Break down the data by year/period, which was previously treated like a "normal" dimension.  Not for this graph!
       */
      const yearsAndPeriodsData = {};
      const yearsAndPeriodsKeys = [];
      if (this.yearDimension && this.periodDimension && this.yearsAndPeriodsAsBars) {
        yearsAndPeriodsData['Not Specified Not Specified'] = [];
        for(const yearResponseValue of this.yearDimension.responseValues) {
          for (const periodResponseValue of periodDimension.responseValues) {
            const key = `${periodResponseValue.as} ${yearResponseValue.as}`;
            if (!yearsAndPeriodsData[key]) yearsAndPeriodsData[key] = [];
            yearsAndPeriodsKeys.push(key);
          }
        }
      } else if (this.yearDimension && this.yearsAndPeriodsAsBars) {
        yearsAndPeriodsData['Not Specified'] = [];
        for(const yearResponseValue of this.yearDimension.responseValues) {
          const key = yearResponseValue.as;
          if (!yearsAndPeriodsData[key]) yearsAndPeriodsData[key] = [];
          yearsAndPeriodsKeys.push(key);
        }
      } else if (this.periodDimension && this.yearsAndPeriodsAsBars) {
        yearsAndPeriodsData['Not Specified'] = [];
        for (const periodResponseValue of this.periodDimension.responseValues) {
          const key = periodResponseValue.as;
          if (!yearsAndPeriodsData[key]) yearsAndPeriodsData[key] = [];
          yearsAndPeriodsKeys.push(key);
        }
      } else {
        this.yearsAndPeriodsAsBars = false;
      }

      let outputData;
      let allDimensions;
      if (this.yearsAndPeriodsAsBars) {
        JSON.parse(JSON.stringify(this.chartData)).forEach(dataRow => {
          const key = `${this.periodDimension ? dataRow[`dimension${this.periodDimensionIndex}Value`] : ''} ${this.yearDimension ? dataRow[`dimension${this.yearDimensionIndex}Value`] : ''}`.trim();
          if (this.periodDimension) dataRow[`dimension${this.periodDimensionIndex}Value`] = 'REPLACE';
          if (this.yearDimension) dataRow[`dimension${this.yearDimensionIndex}Value`] = 'REPLACE';
          yearsAndPeriodsData[key].push(dataRow);
        });
        outputData = [];
        allDimensions = [];
        yearsAndPeriodsKeys.forEach(key => {
          const data = getDimensionElementTotals(yearsAndPeriodsData[key]);
          Object.keys(data).forEach(dataKey => {
            if (!(/REPLACE/g.test(dataKey))) {
              allDimensions.push(dataKey); 
              return;
            }
            const newDataKey = dataKey.replace(/REPLACE(\,\s)?/g,'');
            data[newDataKey] = data[dataKey];
            delete data[dataKey];
            allDimensions.push(newDataKey);
          });
          outputData.push({
            key,
            data
          });
        });
        allDimensions = _.uniq(allDimensions);
      } else {
        outputData = [{key: 'all', data: getDimensionElementTotals(JSON.parse(JSON.stringify(this.chartData)))}];
        allDimensions = Object.keys(outputData[0].data);
      }

      //colour stuff
      const greySteps = Math.floor((maxColor[0] - minColor[0]) / outputData.length);

      // keep track of how high we need our axis to be.
      let maxScore = 0;

      //labels
      if (!this.skipOverallBar) newChartData.labels.push('Overall');
      allDimensions.forEach(dimension => {
        if (dimension === 'totals') return;
        newChartData.labels.push(dimension);
      });

      // normal blue overall bar
      if (!this.yearsAndPeriodsAsBars && !this.skipOverallBar) {
        newChartData.datasets.push({
          label: 'Overall',
          backgroundColor: '#4F81BD',
          data: [this.overallScore],
          stack: 'stack0',
          datalabels: {
            anchor: 'end',
            align: 'start',
            color: '#000000',
            backgroundColor: 'white',
            offset: -30,
            font: {
              size: '13'
            },
            formatter(value) {
              return value > 0 ? parseFloat(value).toFixed(2) : '';
            }
          }
        });
        maxScore = this.overallScore;
      }


      // output the data.
      outputData.forEach((outputSeries, index) => {
        let dataSetData = _.fill(new Array(!this.skipOverallBar ? allDimensions.length : (allDimensions.length - 1)), 0);
        let dataSetDataIndex = (this.yearsAndPeriodsAsBars || this.skipOverallBar) ? 0 : 1;

        // overall bar?
        if (!this.skipOverallBar && this.yearsAndPeriodsAsBars) {
          dataSetData[0] = getOverallScore(_.values(outputSeries.data.totals.elementScores));
          dataSetDataIndex = 1;
        }

        // get the overall scores
        allDimensions.forEach(dimension => {
          if (dimension === 'totals') return;
          dataSetData[dataSetDataIndex] = outputSeries.data[dimension] ? getOverallScore(_.values(outputSeries.data[dimension].elementScores)) : 0;
          dataSetDataIndex += 1;
        });

        dataSetData = dataSetData.map(v => {
          v = v.toFixed(2);
          v = Number.parseFloat(v);
          return v;
        });

        // add the dataset.
        newChartData.datasets.push({
          label: outputSeries.key,
          backgroundColor: `rgba(${maxColor[0] + (greySteps * index)}, ${maxColor[1] + (greySteps * index)}, ${maxColor[1] + (greySteps * index)}, 1)`,
          data: dataSetData,
          stack: `stack${index + 1}`,
          datalabels: {
            anchor: 'end',
            align: 'start',
            color: 'black',
            backgroundColor: 'white',
            offset: -30,
            font: {
              size: '13'
            },
            formatter(value) {
              return value > 0 ? value.toFixed(2) : null;
            }
          }
        });

        maxScore = dataSetData.reduce((accumulator, dataPoint) => dataPoint > accumulator ? dataPoint : accumulator, maxScore);


      });

      // fill in missing data
      for (let i = 0; i < 4; i++) {
        for (let j = 0; j < newChartData.labels.length; j++) {
          newChartData.datasets[i].data.unshift(null);
        }
      }

      // stuff to do with years and periods as bars
      if (!this.yearsAndPeriodsAsBars) {
        newChartData.datasets.forEach((dataset, index) => {
          if (dataset.stack) delete dataset.stack;
          if (index < 4) delete dataset.xAxisID;
        });

      } else {
        newChartData.datasets.forEach((dataset, index) => {
          if (index < 4) dataset.xAxisID = 'valuesx';
        });
      }

      // last label.
      newChartData.labels.push('');

      // now render!
      this.renderChart(newChartData, {
        events:[],
        responsive: false,
        maintainAspectRatio: true,
        title: {
          display: false,
          text: 'Chart.js Bar Chart - Stacked'
        },
        legend: this.yearsAndPeriodsAsBars ? {
          display: true,
          position: 'top',
          labels: {
            filter: function(item, chart) {
              // filter out the traffic lights.
              return !(/^[1-4](st|nd|rd|th)\sGear$/.test(item.text));
            }
          }
        }: false,
        layout: {
          padding: {
            right: 0,
            bottom: 0,
            top: 0
          }
        },
        scales: {
          xAxes: [{
            id: 'gearx',
            stacked: true,
            ticks: { display: true, autoSkip: false, fontColor: 'black'},
            gridLines: {
              display: false, color: '#000000'
            }
          },
          {
            id: 'valuesx',
            display: false,
            stacked: true,
            ticks: { display: false, autoSkip: false },
            gridLines: {
              display: false, color: '#000000'
            },
            barPercentage: 1,
            categoryPercentage: 1
          }],
          yAxes: [
            {
              id: 'gears',
              display: true,
              stacked: true,
              type: 'linear',
              ticks: {
                display: true, min: 0, max: maxScore > 90 ? 110 : 100, stepSize: 10,
                fontColor: 'black'
              },
              gridLines: {
                display: true,
                color: '#000000',
                lineWidth: 1,
                borderDashOffset: -10,
                zeroLineColor: '#000000',
                zeroLineWidth: 1,
                zeroLineBorderDash: [this.width - 85, this.width - 100],
                zeroLineBorderDashOffset: 0,
                borderDash: [this.width - 85, this.width - 100],
                drawBorder: false,
                drawOnChartArea: true,
                drawTicks: false
              }
            }]
        },
        showTooltips: false,
        plugins: {
          datalabels: {
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/graphs/GearBar.js